import React, { memo } from 'react'

import * as styles from './keyValue.module.scss'
import Svg from '../svg/svg'
import { KeyValueProps } from './types'
import classNames from 'classnames'

const KeyValue = ({ className, label, value, svgId }: KeyValueProps) => {
   const displayValue = value == null ? 'n/a' : !value ? '-' : value

   // Barcodes will need to be broken if they are too long
   const valueClass = classNames(
      styles.value,
      {
         [styles.breakDisplay]: label === 'Barcode'
      }
   )

   return (
      <div className={className}>
         <div className={styles.label}>
            {svgId && <Svg id={svgId} width={22} height={17} />}
            {label}
         </div>
         <div className={valueClass}>{displayValue}</div>
      </div>
   )
}

export default memo(KeyValue)
